import { configureStore } from '@reduxjs/toolkit'
import dragReducer from '../Reducers/dragReducer'
import partialTripReducer from '../Reducers/partialTripReducer'
import globalDataReducer from '../Reducers/globalDataReducer'
import updateHeaderReducer from '../Reducers/updateHeaderReducer'
import { createStateSyncMiddleware } from "redux-state-sync";
import loginReducer from '../Reducers/loginReducer'
import updateSideNavReducer from '../Reducers/updateSideNavReducer'
import sideBarReducer from '../Reducers/sideBarReducer'
import pinReducer  from '../Reducers/pinReducer'
import schedulerTrayReducer  from '../Reducers/schedulerTrayReducer'
import tripRoutesReducer from '../Reducers/tripRoutesReducer'
import refreshTimeReduce from '../Reducers/refreshTimeReduce'
import shipmentMovementsReducer from '../Reducers/shipmentMovementsReducer'
import areaSelectionReducer from '../Reducers/areaSelectionReducer'
import markerSelectionReducer from '../Reducers/markerSelectReducer'
import mapRefreshReducer from '../Reducers/mapRefreshReducer'
import mapDataReducer from '../Reducers/mapDataReducer'
import listSelectionReducer from '../Reducers/listSelectionReducer'
import movementsReducer from '../Reducers/movementsReducer'

export default configureStore({
    reducer: {
        drag: dragReducer,
        partialTrip: partialTripReducer,
        globalData: globalDataReducer,
        updateHeader: updateHeaderReducer,
        updateSideNav: updateSideNavReducer,
        login: loginReducer,
        sideBar: sideBarReducer,
        pin: pinReducer,
        schedulerTray: schedulerTrayReducer,
        tripRoutes: tripRoutesReducer,
        refreshTime: refreshTimeReduce,
        shipmentMovements: shipmentMovementsReducer,
        areaSelection: areaSelectionReducer,
        markerSelection: markerSelectionReducer,
        mapRefresh: mapRefreshReducer,
        mapData: mapDataReducer,        
        listSelection: listSelectionReducer,
        movement:movementsReducer
    },
    middleware: [createStateSyncMiddleware()]

})

